import { useState } from 'react'
import { api, ApiError } from './api.js'

/**
 * Вход в два шага: почта → код из письма.
 *
 * Сообщение после запроса кода намеренно не говорит, есть ли адрес в списке
 * доступа: ответ сервера одинаковый для любой почты, и интерфейс это не выдаёт.
 */
export function Login({ onDone }: { onDone: () => void }) {
  const [step, setStep] = useState<'email' | 'code'>('email')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [note, setNote] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function requestCode(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const result = await api.requestCode(email)
      setNote(result.message)
      setStep('code')
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось запросить код')
    } finally {
      setBusy(false)
    }
  }

  async function verify(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api.verify(email, code)
      onDone()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось войти')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <h1>CRM контента</h1>
      <p className="muted small" style={{ marginTop: 0 }}>Кузница контента</p>
      <div className="card">
        {step === 'email' ? (
          <form onSubmit={requestCode}>
            <div className="field">
              <label htmlFor="email">Почта</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="вы@почта.ру"
              />
            </div>
            <button className="primary" type="submit" disabled={busy || !email}>
              {busy ? 'Отправляю…' : 'Получить код'}
            </button>
          </form>
        ) : (
          <form onSubmit={verify}>
            <p className="small muted" style={{ marginTop: 0 }}>{note}</p>
            <div className="field">
              <label htmlFor="code">Код из письма</label>
              <input
                id="code"
                className="code-input"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                required
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                placeholder="______"
              />
            </div>
            <div className="row">
              <button className="primary" type="submit" disabled={busy || code.length < 6}>
                {busy ? 'Проверяю…' : 'Войти'}
              </button>
              <button type="button" className="ghost" onClick={() => { setStep('email'); setCode(''); setError('') }}>
                Другая почта
              </button>
            </div>
          </form>
        )}
        {error && <p className="error small">{error}</p>}
      </div>
    </div>
  )
}
